import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { createSpaceGroup } from '../lib/space-groups';
import { spaceGroupsKeys } from '../query-keys/space-groups';

export const useCreateSpaceGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation(['spaceGroups', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) => createSpaceGroup(name),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: spaceGroupsKeys.lists(),
        });
      });
      toast.success(t('spaceGroups:common.createGroupDialog.successCreate'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
